export const SET_FIRST_LOAD_COUNTER = "SET_FIRST_LOAD_COUNTER";
export function action_updateFirstLoadCounter(loaded) {
	return { type: SET_FIRST_LOAD_COUNTER, payload: loaded };
}

export const SET_FIRST_LOAD_LIST = "SET_FIRST_LOAD_LIST";
export function action_updateFirstLoadList(loaded) {
	return { type: SET_FIRST_LOAD_LIST, payload: loaded };
}

export const SET_ISPANEL_NOTIFICATION_OPEN = "SET_ISPANEL_NOTIFICATION_OPEN";
export function action_updateIsPanelNotificationOpen(isOpen) {
	return { type: SET_ISPANEL_NOTIFICATION_OPEN, payload: isOpen };
}

export const SET_ALERT_SEARCH_IDENTIFIERS = "SET_ALERT_SEARCH_IDENTIFIERS";
export function action_updateNotificationSearchIdentifiers(rootId, itemId) {
	return { type: SET_ALERT_SEARCH_IDENTIFIERS, payload: {rootId: rootId, itemId: itemId} };
}

export const SET_ALERT_COUNTER = "SET_ALERT_COUNTER";
export function action_updateAlertCounter(counter) {
	return { type: SET_ALERT_COUNTER, payload: counter };
}

export const SET_ALERT_DIALOG_TITLE = "SET_ALERT_DIALOG_TITLE";
export function action_updateAlertDialogTitle(title) {
	return { type: SET_ALERT_DIALOG_TITLE, payload: title };
}

export const SET_ALERT_LIST = "SET_ALERT_LIST";
export function action_updateAlertList(alertList) {
	return { type: SET_ALERT_LIST, payload: alertList };
}